import React, { useMemo } from 'react'
import { sidebarRoutes } from '../routes'
import { Link } from 'react-router-dom'
import { RouteId } from 'types/frontend_models/navigation/RouteId'
import { fixPublicPath } from 'functions/url/URLFunctions';

interface IProps
{
    sidebarOpen: boolean
}

export function SidebarCompanyLogo(props: IProps)
{
    const route = useMemo(() =>
    {
        return sidebarRoutes.find(route => route.routeId === RouteId.home)
    }, []);

    // const logoUrl = useMemo(() =>
    // {
    //     return props.sidebarOpen ? fixPublicPath('/images/logo/AptecLogo.png') : fixPublicPath('/images/logo/AptecLogoImg.png');
    // }, [props.sidebarOpen]);
    // const logoElement = <img className="logo" src={logoUrl} alt="logo" />;

    if (route) {
        return (
            <Link to={route.path} tabIndex={-1} className="logo-container">
                {/* {logoElement} */}
                <img className="logo-icon" src={fixPublicPath("/images/logo/AptecLogoImg.png")} alt="aptec logo icon" />
                <img className="logo-text" src={fixPublicPath("/images/logo/AptecLogoText.png")} alt="aptec logo text" />
            </Link>

        )
    } else {
        throw new Error('Sidebar logo route not found!');
    }
}